(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon/assets/javascripts/coupon.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon/assets/javascripts/coupon.js');
"use strict";


const {
  useContext,
  useState
} = React;
const {
  productIds
} = svs.utils.products;
const {
  DrawContext
} = svs.components.tipsen.drawProvider;
const {
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const {
  useIsCurrentDrawPlayable
} = svs.components.tipsen.hooks;
const {
  CouponRow,
  CouponSingleRows
} = svs.components.tipsen.coupon;
const {
  useObserveSettings
} = svs.components.tipsen.coupon.hooks;
const {
  useCouponId
} = svs.components.tipsen.couponId;
const {
  selectNumberOfBoards
} = svs.components.tipsen.engine.selectors.couponSelectors;
const {
  selectShowMatchAnalysesInCoupon
} = svs.components.tipsen.selectors;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  useSelector
} = ReactRedux;
const Paper = svs.ui.ReactPaper;
const Button = svs.ui.ReactButton;
const {
  ScrollableButtonGroup
} = svs.components.tipsen.scrollableButtonGroup;
const containerSelector = '.coupon-singels-mobile-boards';
const {
  FetchDrawAnalysesByHook
} = svs.components.tipsen.hooks;
const {
  LABELS_1X2
} = svs.components.sport.tipsenShared.constants;
const {
  CurrentVideoDisplay
} = svs.components.tipsen.coupon;
const Coupon = () => {
  const couponId = useCouponId();
  const draw = useCurrentDraw();
  const boardSize = useSelector(state => selectNumberOfBoards(state, couponId));
  const isDrawPlayable = useIsCurrentDrawPlayable();
  const {
    eventNumber,
    productId
  } = useContext(DrawContext);
  const [selectedBoard, setSelectedBoard] = useState(0);
  const isSingelRows = boardSize > 1;
  const mappedBoards = [];
  for (let i = 0; i < boardSize; i++) {
    mappedBoards.push(i);
  }
  const showMatchAnalysesInCoupon = useSelector(selectShowMatchAnalysesInCoupon);
  const shouldFetchMatchAnalyses = !showMatchAnalysesInCoupon.hideAll;
  const outcomeLabels = LABELS_1X2;
  useObserveSettings();
  const showVideoAnalysis = productId === productIds.STRYKTIPSET && svs.core.detect.feature('ft-pool-betting-video-analyses');
  const renderCoupon = () => isSingelRows ? React.createElement(CouponSingleRows, {
    couponId: couponId,
    events: draw.drawEvents,
    hasDisabledBets: !isDrawPlayable,
    outcomeLabels: outcomeLabels,
    selectedBoard: selectedBoard
  }) : React.createElement("ol", {
    className: "coupon-rows",
    "data-testid": "standard-coupon"
  }, draw.drawEvents.map((drawEvent, index) => React.createElement(CouponRow, {
    board: 0,
    couponId: couponId,
    event: index,
    hasDisabledBets: !isDrawPlayable,
    isSelected: drawEvent.eventNumber === eventNumber,
    key: drawEvent.eventNumber,
    outcomeLabels: outcomeLabels
  })));
  return React.createElement(React.Fragment, null, useMediaQuery(breakpoints.down(BREAKPOINT_AM)) && isSingelRows && React.createElement("div", {
    className: "coupon-singels-mobile-boards",
    role: "radiogroup"
  }, React.createElement(ScrollableButtonGroup, {
    containerSelector: containerSelector
  }, mappedBoards.map(board => React.createElement(Button, {
    "aria-checked": selectedBoard === mappedBoards.indexOf(board),
    className: "coupon-singels-mobile-boards-button"
    ,
    key: board,
    onClick: () => setSelectedBoard(mappedBoards.indexOf(board))
  }, React.createElement("span", null, selectedBoard === mappedBoards.indexOf(board) ? "Rad ".concat(board + 1) : board + 1))))), React.createElement(Paper, {
    "aria-label": "Kupong",
    branding: "sport",
    className: "coupon",
    Component: "section"
  }, showVideoAnalysis && React.createElement(CurrentVideoDisplay, null), shouldFetchMatchAnalyses && React.createElement(FetchDrawAnalysesByHook, {
    drawNumber: draw.drawNumber,
    productId: draw.productId
  }), renderCoupon()));
};
setGlobal('svs.components.tipsen.coupon.Coupon', Coupon);

 })(window);